// used to output price for mannually set price
const outputManuallySetPrice = (price: number) => {
  return price?.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  });
};

export default outputManuallySetPrice;
